import {
  CATEGORY_USER_SUCCESS,
  GET_CATEGORY_SUCCESS,
  GET_AGENT_SUCCESS,
  GET_ALL_BILLING_TYPES_SUCCESS,
  GET_USER_BY_PROJECT_ERROR,
  GET_USER_BY_PROJECT_SUCCESS,
  SAVE_UPLOAD_GATEGORY_SUCCESS,
  SUB_CATEGORY_SUCCESS,
  CATEGORY_USER_CATEGORY_LINK,
  CATEGORY_USER_CATEGORY_LINK_SUCCESS,
  CATEGORY_USER_CATEGORY_LINK_ERROR,
  CATEGORY_USER,
  CATEGORY_USER_ERROR,
  GET_PROJECT_STATUS,
  GET_PROJECT_STATUS_SUCCESS,
  GET_PROJECT_STATUS_TOTAL_HOURS,
  GET_PROJECT_STATUS_TOTAL_HOURS_SUCCESS,
  GET_PROJECT_STATUS_TOTAL_HOURS_ERROR,
} from "./actiontype"

const initialState = {
  updatecategory: null,
  updateUserCategory: null,
  updateSubCategory: null,
  getUsersLists: null,
  getUsersError: null,
  getallagentslist: [],
  getallbillingtypes: [],
  getallprojectstatus: null,
  getallprojectstatustotalhours:null
}

const manageclient = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORY_SUCCESS:
      state = {
        ...state,
        updatecategory: null,
        updateUserCategory: null,
        updateSubCategory: null,
        categorylist: action.payload,
      }
      break
    case SAVE_UPLOAD_GATEGORY_SUCCESS:
      state = {
        ...state,
        updatecategory: action.payload,
        updatecategoryerror: null,
      }
      break
    case CATEGORY_USER:
      state = {
        ...state,
        updateUserCategoryaa: action.payload,
        updateUserCategoryerror: null,
      }
      break
    case CATEGORY_USER_SUCCESS:
      state = {
        ...state,
        updateUserCategory: action.payload,
        updateUserCategoryerror: null,
      }
      break
    case CATEGORY_USER_ERROR:
      state = {
        ...state,
        updateUserCategory: action.payload,
        updateUserCategoryerror: null,
      }
      break
    case SUB_CATEGORY_SUCCESS:
      state = {
        ...state,
        updateSubCategory: action.payload,
        updateSubCategoryerror: null,
      }
      break
    case GET_USER_BY_PROJECT_SUCCESS:
      state = {
        ...state,
        getUsersLists: {
          ...state.getUsersLists,
          [action?.projectID]: action?.payload?.usersData,
        },
        getUsersError: null,
      }
      break
    case GET_USER_BY_PROJECT_ERROR:
      state = {
        ...state,
        getUsersError: action?.payload,
      }
      break
    case GET_AGENT_SUCCESS:
      state = {
        ...state,
        getallagentslist: action?.payload?.agentMasters,
      }
      break
    case GET_ALL_BILLING_TYPES_SUCCESS:
      state = {
        ...state,
        getallbillingtypes: action?.payload?.billingTypes,
      }
      break
    // careate category link
    case CATEGORY_USER_CATEGORY_LINK:
      state = {
        ...state,
        usercategorylinkError: null,
      }
      break
    case CATEGORY_USER_CATEGORY_LINK_SUCCESS:
      state = {
        ...state,
        usercategorylinkSuccess: action?.payload,
        usercategorylinkError: null,
      }
      break
    case CATEGORY_USER_CATEGORY_LINK_ERROR:
      state = {
        ...state,
        usercategorylinkError: action?.payload,
      }
      break

    //get project status
    case GET_PROJECT_STATUS:
      state = {
        ...state,
        getallprojectstatus: action?.payload,
      }
      break
    case GET_PROJECT_STATUS_SUCCESS:
      state = {
        ...state,
        getallprojectststusSuccess: action?.payload,
        usercategorylinkError: null,
      }
      break
    // GET PROJECT TOTAL HOURS
    
    case GET_PROJECT_STATUS_TOTAL_HOURS:
      state = {
        ...state,
        getallprojectstatustotalhours: action?.payload,
        getallprojectsttustotalError: null,
      }
      break
    case GET_PROJECT_STATUS_TOTAL_HOURS_SUCCESS:
      state = {
        ...state,
        getallprojectsttustotalSuccess: action?.payload,
        getallprojectsttustotalError: null,
      }
      break
    case GET_PROJECT_STATUS_TOTAL_HOURS_ERROR:
      state = {
        ...state,
        getallprojectsttustotalError: action?.payload,
      }
      break
    // end project total hours
    default:
      state = { ...state }
      break
  }
  return state
}

export default manageclient
